export default "__VITE_ASSET__BNi0pPj7__"